import React from "react";
import { Navigate } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import CallsContainer from "pages/Calls/CallsContainer";
import ExtractedDumpsContainer from "pages/ExtractedDumps/ExtractedDumpsContainer";
import RawPacketsContainer from "pages/RawPackets/RawPacketsContainer";
import FilesContainer from "pages/Files/FilesContainer";
// import LoginContainer from "pages/Login/LoginContainer";

type PrivateRouteProps = {
    children: React.ReactNode;
};

const PrivateRoute = ({ children }: PrivateRouteProps) => {
    const isAuthenticated = !!localStorage.getItem("token");
    // return isAuthenticated ? 
    return <>{children}</>;
    // : <Navigate to="/login" />;
};

const RoutesComponent = () => {
    const isAuthenticated = !!localStorage.getItem("token");

    return (
        <Routes>
            <Route path="/login" element={
                // isAuthenticated ?
                <Navigate to="/calls" replace />
                // : <LoginContainer />
            } />
            <Route
                path="/calls"
                element={
                    <PrivateRoute>
                        <CallsContainer />
                    </PrivateRoute>
                }
            />
            <Route
                path="/raw-packets"
                element={
                    <PrivateRoute>
                        <RawPacketsContainer />
                    </PrivateRoute>
                }
            />
            <Route
                path="/extracted-dumps"
                element={
                    <PrivateRoute>
                        <ExtractedDumpsContainer />
                    </PrivateRoute>
                }
            />
            <Route
                path="/Files"
                element={
                    <PrivateRoute>
                        <FilesContainer />
                    </PrivateRoute>
                }
            />
            <Route
                path="*"
                element={
                    // isAuthenticated ?
                    <Navigate to="/calls" replace />
                    // : <Navigate to="/login" replace />
                }
            />
        </Routes>
    );
};

export default RoutesComponent;